import React, { Component } from 'react';

class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
    };
    this.debouncedTimeout;
  }

  handleChange(e) {
    this.setState({
      inputValue: e.target.value,
    });

    clearTimeout(this.debouncedTimeout);
    this.debouncedTimeout = setTimeout(this.handleSubmit.bind(this), 1000);
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      clearTimeout(this.debouncedTimeout);
      this.handleSubmit();
    }
  }

  handleSubmit() {
    this.props.search(this.state.inputValue);
  }

  render() {
    return (
      <div className="fv-search-app__form">
        <i className="icon-search" />
        <input
          type="text"
          id="search-app__input"
          placeholder="Search live and on demand TV"
          value={this.state.inputValue}
          onChange={this.handleChange.bind(this)}
          onKeyPress={this.handleKeyPress.bind(this)}
        />
      </div>
    );
  }
}

export default Form;
